<template>
  <div class="interested">
    <section>
      <div class="grid-container">
        <div class="row">
          
          <div class="col-6">
            <h3>Email:</h3>
          </div>
          <div class="col-6">
            <h3>When:</h3>
          </div>
        </div>

        <div class="row" v-for="row in preReg">
          
          <div class="col-6">
            {{ row.email }}
          </div>
          <div class="col-6">
            {{ formatDate(row.when) }}
          </div>
        </div>

      </div>
    </section>

    <section>
      <div class="grid-container">
        <div class="row">
          
          <div class="col-12">
            <h3>BCC Combined Link:</h3>
            <a :href="bccLink">
              {{ bccLink }}
            </a>

          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { db } from '@/firebase'
import dateFormat from 'dateformat'

export default {
  name: 'Interested',
  firebase: function () {
    return {
      preReg: {
        source: db.ref('pre-registration')
      }
    }
  },
  methods: {
    formatDate (date) {
      return dateFormat(date, 'h:MM:ss TT - dS mmmm yyyy')
    }
  },
  computed: {
    bccLink: function () {
      let string = 'mailto:?bcc='
      for (let item in this.preReg) {
        string = string + this.preReg[item].email + ','
      }
      return string
    }
  }
}
</script>



// WEBPACK FOOTER //
// Interested.vue?02754521